"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TextField = _interopRequireDefault(require("@eig-builder/core-ui/TextField"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

// Core
// Component
var RenderInput = function RenderInput(inputProps) {
  var InputProps = inputProps.InputProps,
      ref = inputProps.ref,
      dataElementSuffix = inputProps.dataElementSuffix,
      other = (0, _objectWithoutProperties2["default"])(inputProps, ["InputProps", "ref", "dataElementSuffix"]);
  return _react["default"].createElement(_TextField["default"], (0, _extends2["default"])({
    fullWidth: true,
    InputProps: (0, _objectSpread2["default"])({
      inputRef: ref
    }, InputProps),
    InputLabelProps: {
      shrink: true
    },
    variant: "outlined",
    dataElementLocation: _taggingHelper.DataElementLocations.BODY,
    dataElementLabel: "control-autocomplete-multiselect-textfield-".concat(dataElementSuffix),
    dataElementId: "control-autocomplete-multiselect-textfield-".concat(dataElementSuffix)
  }, other, {
    className: "autocomplete-field-textfield",
    onBlur: InputProps.onBlur
  }));
};

RenderInput.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].object.isRequired,
  InputProps: _propTypes["default"].object
};
var _default = RenderInput;
exports["default"] = _default;